// The API is on the same domain, served at the /api endpoint.
const API_BASE_URL = '/';

if (!API_BASE_URL) {
    throw new Error("API_BASE_URL is not defined.");
}

/**
 * Fetches files and folder information from the backend API.
 * @param {string} path - The relative path of the folder to fetch.
 * @returns {Promise<object>} - A promise that resolves to the API response data.
 */
export const fetchFiles = async (path) => {
    // The final URL will be "/api/files?path=..."
    const url = `${API_BASE_URL}api/files?path=${encodeURIComponent(path)}`;
    
    try {
        const response = await fetch(url);

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error("Failed to fetch files:", error);
        // Re-throw the error so the calling component can handle it
        throw error;
    }
};

/**
 * Gets the direct download link for a file from the backend.
 * @param {string} fileId - The ID of the file to download.
 * @returns {string} - The full URL for downloading the file.
 */
export const getDownloadLink = (fileId) => {
    // The final URL will be "/api/download/some-file-id"
    return `${API_BASE_URL}api/download/${fileId}`;
};